import React, {useState} from 'react';
import LoginAlert from "../../../Components/EmptyState/LoginAlert";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import Agent from "../../../Network/Agent";
import {Link} from "react-router-dom";
import {getGeneratedRoute, RouteEnumFinal} from "../../../Config/RouteEnum";
import PanelRow from "../../../Components/Store/ui/PanelRow";
import ButtonPrimary from "../../../Components/Elements/ButtonPrimary";
import {getStoreName} from "../../../Components/Utils/getStoreName";
import {Modal} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChartColumn, faQrcode} from "@fortawesome/free-solid-svg-icons";
import {Swiper, SwiperSlide} from "swiper/react";
import Cookies from "universal-cookie";
import {KEY_TOKEN, projectUrl, SharedConfig} from "../../../Config/SharedConfig";
import {getRedirectUrl} from "../../../Components/Utils/getRedirectUrl";

const Panel = ({

}) => {
    const storeUsernameInUrl = getStoreName()

    const [username, setUsername] = useState(null)
    const [usernameError, setUsernameError] = useState(null)
    const [isSubmittingUsername, setIsSubmittingUsername] = useState(false)

    const [title, setTitle] = useState(null)
    const [titleError, setTitleError] = useState(null)
    const [isSubmittingTitle, setIsSubmittingTitle] = useState(false)

    const [description, setDescription] = useState(null)
    const [descriptionError, setDescriptionError] = useState(null)
    const [isSubmittingDescription, setIsSubmittingDescription] = useState(false)

    const [slogan, setSlogan] = useState(null)
    const [sloganError, setSloganError] = useState(null)
    const [isSubmittingSlogan, setIsSubmittingSlogan] = useState(false)
    
    const [selectedAddress, setSelectedAddress] = useState(null)
    const [isSubmittingAddress, setIsSubmittingAddress] = useState(false)

    const [activeModal, setActiveModal] = useState(null)

    const queryClient = useQueryClient()

    const {data: store, isLoading: isLoadingStore} = useQuery({
        queryKey: ['storePanelInfo', storeUsernameInUrl],
        queryFn: async () => {
            const response = await Agent.Store.getInfo(storeUsernameInUrl)
            const { store } = response.data.result
            return store
        }
    })
    const {data: themes, isLoading: isLoadingThemes} = useQuery({
        queryKey: ['storePanelThemes', storeUsernameInUrl],
        queryFn: async () => {
            const response = await Agent.Theme.getList()
            const { themes } = response.data.result
            return themes
        }
    })
    const {data: addresses, isLoading: isLoadingAddresses} = useQuery({
        queryKey: ['storePanelAddresses', storeUsernameInUrl],
        queryFn: async () => {
            const response = await Agent.Address.list()
            const { addresses } = response.data.result
            return addresses
        }
    })

    const handleSubmitUsername = (e) => {
        e.preventDefault()
        setIsSubmittingUsername(true)
        Agent.Store.updateUsername(storeUsernameInUrl, username)
            .then(response => {
                const store = response.data.result.store
                const token = Agent.getAuthToken()
                const cookies = new Cookies();
                cookies.remove(KEY_TOKEN)
                cookies.remove(KEY_TOKEN, { path: '/' });
                cookies.remove(KEY_TOKEN, {
                    path: '/',
                    domain: `.${projectUrl}`,
                });
                cookies.remove(KEY_TOKEN, {
                    path: '/',
                    domain: `${projectUrl}`,
                });
                window.location.href = getRedirectUrl(store.username, token);
            })
            .catch(error => {
                console.log(error)
                const errorMessage = error.response.data.errors.at(0).message
                setUsernameError(errorMessage)
                setIsSubmittingUsername(false)
            })
    }

    const handleSubmitTitle = (e) => {
        e.preventDefault()
        setIsSubmittingTitle(true)
        Agent.Store.updateTitle(storeUsernameInUrl, title)
            .then(response => {
                queryClient.invalidateQueries({
                    queryKey: ['storePanelInfo', storeUsernameInUrl],
                    exact: true
                })
                queryClient.invalidateQueries({
                    queryKey: ['store', getStoreName()],
                    exact: true
                })
                setTitleError(null)
                setIsSubmittingTitle(false)
                setActiveModal(null)
            })
            .catch(error => {
                const errorMessage = error.response.data.errors.at(0).message
                setTitleError(errorMessage)
                setIsSubmittingTitle(false)
            })
    }

    const handleSubmitDescription = (e) => {
        e.preventDefault()
        setIsSubmittingDescription(true)
        Agent.Store.updateBiography(storeUsernameInUrl, description)
            .then(response => {
                queryClient.invalidateQueries({
                    queryKey: ['storePanelInfo', storeUsernameInUrl],
                    exact: true
                })
                queryClient.invalidateQueries({
                    queryKey: ['store', getStoreName()],
                    exact: true
                })
                setDescriptionError(null)
                setIsSubmittingDescription(false)
                setActiveModal(null)
            })
            .catch(error => {
                const errorMessage = error.response.data.errors.at(0).message
                setDescriptionError(errorMessage)
                setIsSubmittingDescription(false)
            })
    }

    const handleSubmitSlogan = (e) => {
        e.preventDefault()
        setIsSubmittingSlogan(true)
        Agent.Store.updateSlogan(storeUsernameInUrl, slogan)
            .then(response => {
                queryClient.invalidateQueries({
                    queryKey: ['storePanelInfo', storeUsernameInUrl],
                    exact: true
                })
                queryClient.invalidateQueries({
                    queryKey: ['store', getStoreName()],
                    exact: true
                })
                setSloganError(null)
                setIsSubmittingSlogan(false)
                setActiveModal(null)
            })
            .catch(error => {
                const errorMessage = error.response.data.errors.at(0).message
                setSloganError(errorMessage)
                setIsSubmittingSlogan(false)
            })
    }

    const handleSubmitAddress = (e) => {
        e.preventDefault()
        setIsSubmittingAddress(true)
        Agent.Store.updateAddress(storeUsernameInUrl, selectedAddress)
            .then(response => {
                queryClient.invalidateQueries({
                    queryKey: ['storePanelInfo', storeUsernameInUrl],
                    exact: true
                })
                queryClient.invalidateQueries({
                    queryKey: ['store', getStoreName()],
                    exact: true
                })
                setIsSubmittingAddress(false)
                setActiveModal(null)
            })
            .catch(error => {
                console.log(error)
                setIsSubmittingAddress(false)
            })
    }

    const handleSubmitListType = (type) => {
        Agent.Store.updateListType(storeUsernameInUrl, type)
            .then(response => {
                queryClient.invalidateQueries({
                    queryKey: ['storePanelInfo', storeUsernameInUrl],
                    exact: true
                })
                queryClient.invalidateQueries({
                    queryKey: ['store', getStoreName()],
                    exact: true
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    const handleSubmitTheme = (theme) => {
        Agent.Store.updateTheme(storeUsernameInUrl, theme)
            .then(response => {
                queryClient.invalidateQueries({
                    queryKey: ['storePanelInfo', storeUsernameInUrl],
                    exact: true
                })
                queryClient.invalidateQueries({
                    queryKey: ['store', getStoreName()],
                    exact: true
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    if(isLoadingStore || isLoadingThemes || isLoadingAddresses) {
        return (
            <div className='shimmer-container'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='line-title shimmer mt-20'/>
                        </div>
                    </div>
                    <div className='row g-4 mt-24'>
                        <div className='col-12'>
                            <div className='row align-items-center justify-content-between'>
                                <div className='col-7'>
                                    <div className='line-title shimmer'/>
                                    <div className='line-paragraph shimmer mt-16'/>
                                </div>
                                <div className='col-5'>
                                    <div className='d-flex justify-content-end'>
                                        <div className='line-title shimmer'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='row align-items-center justify-content-between'>
                                <div className='col-7'>
                                    <div className='line-title shimmer'/>
                                    <div className='line-paragraph shimmer mt-16'/>
                                </div>
                                <div className='col-5'>
                                    <div className='d-flex justify-content-end'>
                                        <div className='line-title shimmer'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='row align-items-center justify-content-between'>
                                <div className='col-7'>
                                    <div className='line-title shimmer'/>
                                    <div className='line-paragraph shimmer mt-16'/>
                                </div>
                                <div className='col-5'>
                                    <div className='d-flex justify-content-end'>
                                        <div className='line-title shimmer'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='row align-items-center justify-content-between'>
                                <div className='col-7'>
                                    <div className='line-title shimmer'/>
                                    <div className='line-paragraph shimmer mt-16'/>
                                </div>
                                <div className='col-5'>
                                    <div className='d-flex justify-content-end'>
                                        <div className='line-title shimmer'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    if (!store?.isOwner) {
        return (
            <LoginAlert/>
        )
    }
    return (
        <>
            {/* basic info */}
            <div className='container mt-15'>
                <div className='row'>
                    <div className='col-12'>
                        <div className='mobile-h3 cl-black'>
                            داشبورد مدیریت فروشگاه
                        </div>
                    </div>
                </div>
                <div className='row mt-12'>
                    {/*username*/}
                    <div className='col-12'>
                        <PanelRow label='نام کاربری'
                                  title={store.username}
                                  modalKey='username'
                                  activeModal={activeModal}
                                  setActiveModal={() => {}}
                                  operationTitle={null}
                        />
                        {/*<PanelRow label='نام کاربری'
                                  title={store.username}
                                  modalKey='username'
                                  activeModal={activeModal}
                                  setActiveModal={setActiveModal}
                                  operationTitle={null}
                        >
                            <div className='mobile-h5 cl-black mt-20'>
                                تغییر نام کاربری فروشگاه
                            </div>
                            <div className='mobile-subtitle-regular cl-subtitle mt-custom-4'>
                                لطفا یک نام کاربری به زبان انگلیسی حداقل 5 کاراکتر وارد کنید:
                            </div>
                            <form onSubmit={(e) => handleSubmitUsername(e)}>
                                <div className='form-group-input-primary mt-32'>
                                    <label className="form-group-label">
                                        <input type="text"
                                               className={`form-group-input dir-ltr ${usernameError ? 'hasError' : ''}`}
                                               defaultValue={store.username}
                                               onChange={(e) => setUsername(e.target.value)}
                                               placeholder='مثال : shahrara'/>
                                    </label>
                                    <div className='mobile-body-1-regular cl-tomato mt-custom-4 mr-8'>
                                        {usernameError}
                                    </div>
                                </div>
                                <div className='mt-32'>
                                    <ButtonPrimary text='تایید'
                                                   mode='dark-mode'
                                                   isLoading={isSubmittingUsername}/>
                                </div>
                            </form>
                        </PanelRow>*/}
                    </div>
                    {/*title*/}
                    <div className='col-12'>
                        <PanelRow label='نام برند'
                                  title={store.title}
                                  modalKey='title'
                                  activeModal={activeModal}
                                  setActiveModal={setActiveModal}>
                            <div className='mobile-h5 cl-black mt-20'>
                                تغییر عنوان فروشگاه
                            </div>
                            <div className='mobile-subtitle-regular cl-subtitle mt-custom-4'>
                                لطفا یک عنوان برای فروشگاه خود انتخاب کنید :
                            </div>
                            <form onSubmit={handleSubmitTitle}>
                                <div className='form-group-input-primary mt-32'>
                                    <label className="form-group-label">
                                        <input type="text"
                                               className={`form-group-input ${titleError ? 'hasError' : ''}`}
                                               defaultValue={store.title}
                                               onChange={(e) => setTitle(e.target.value)}
                                               placeholder='عنوان : شهرآرا'/>
                                    </label>
                                    <div className='mobile-body-1-regular cl-tomato mt-custom-4 mr-8'>
                                        {titleError}
                                    </div>
                                </div>
                                <div className='mt-32'>
                                    <ButtonPrimary text='تایید'
                                                   mode='dark-mode'
                                                   isLoading={isSubmittingTitle}/>
                                </div>
                            </form>
                        </PanelRow>
                    </div>
                    {/*biography*/}
                    <div className='col-12'>
                        <PanelRow label='بایوگرافی'
                                  title={store.description}
                                  modalKey='description'
                                  activeModal={activeModal}
                                  setActiveModal={setActiveModal}>
                            <div className='mobile-h5 cl-black mt-20'>
                                تغییر بایوگرافی
                            </div>
                            <div className='mobile-subtitle-regular cl-subtitle mt-custom-4'>
                                لطفا توضیحات مربوط به فروشگاه خود را بنویسید :
                            </div>
                            <form onSubmit={handleSubmitDescription}>
                                <div className='form-group-textarea-primary mt-32'>
                                    <textarea className='form-group-textarea'
                                              placeholder='بیوگرافی فروشگاه'
                                              defaultValue={store.description}
                                              onChange={(e) => setDescription(e.target.value)}
                                              cols="30"
                                              rows="4"/>
                                    <div className='mobile-body-1-regular cl-tomato mt-custom-4 mr-8'>
                                        {descriptionError}
                                    </div>
                                </div>
                                <div className='mt-32'>
                                    <ButtonPrimary text='تایید'
                                                   mode='dark-mode'
                                                   isLoading={isSubmittingDescription}/>
                                </div>
                            </form>
                        </PanelRow>
                    </div>
                    {/*slogan*/}
                    <div className='col-12'>
                        <PanelRow label='شعار'
                                  title={store.slogan}
                                  modalKey='slogan'
                                  activeModal={activeModal}
                                  setActiveModal={setActiveModal}>
                            <div className='mobile-h5 cl-black mt-20'>
                                تغییر شعار فروشگاه
                            </div>
                            <div className='mobile-subtitle-regular cl-subtitle mt-custom-4'>
                                لطفا یک شعار برای فروشگاه خود انتخاب کنید :
                            </div>
                            <form onSubmit={handleSubmitSlogan}>
                                <div className='form-group-input-primary mt-32'>
                                    <label className="form-group-label">
                                        <input type="text"
                                               className={`form-group-input ${sloganError ? 'hasError' : ''}`}
                                               defaultValue={store.slogan}
                                               onChange={(e) => setSlogan(e.target.value)}
                                               placeholder='مثال : این یک شعار است'/>
                                    </label>
                                    <div className='mobile-body-1-regular cl-tomato mt-custom-4 mr-8'>
                                        {sloganError}
                                    </div>
                                </div>
                                <div className='mt-32'>
                                    <ButtonPrimary text='تایید'
                                                   mode='dark-mode'
                                                   isLoading={isSubmittingSlogan}/>
                                </div>
                            </form>
                        </PanelRow>
                    </div>
                    {/*guild*/}
                    <div className='col-12'>
                        <PanelRow label='صنف و دسته بندی'
                                  title={store.guild?.title || 'صنف فروشگاه خود را انتخاب کنید:'}
                                  href={getGeneratedRoute(RouteEnumFinal.GUILD_LIST_URL_GENERATE)}
                                  linkState={{guildCode : store.guild?.code || 'test'}}
                        />
                    </div>
                    {/*category*/}
                    <div className='col-12'>
                        <PanelRow label='دسته بندی'
                                  title={`${store.categoryCount} عدد دسته بندی`}
                                  href={getGeneratedRoute(RouteEnumFinal.CATEGORY_LIST_URL_GENERATE, storeUsernameInUrl)}/>
                    </div>
                    {/*product*/}
                    <div className='col-12'>
                        <PanelRow label='محصولات'
                                  title={`${store.productCount} عدد محصول`}
                                  href={getGeneratedRoute(RouteEnumFinal.PRODUCT_LIST_SORTING_URL_GENERATE)}
                        />
                    </div>
                    {/*products quick setup*/}
                    <div className='col-12'>
                        <PanelRow label='ویرایش سریع محصولات'
                                  title='ویرایش سریع محصولات'
                                  href={getGeneratedRoute(RouteEnumFinal.CATEGORY_PRODUCT_LIST_URL_GENERATE)}
                                  hasDivider={false}/>
                    </div>
                </div>
            </div>
            <div className='divider-12px bg-gray-custom-1 mt-12'/>
            {/* Address & Location */}
            {/*<div className='container'>
                {
                    store.address
                        ? <div className='row'>
                            <div className='col-12'>
                                <div className='d-flex align-items-center justify-content-between mt-12'>
                                    <div>
                                        <div className='mobile-subtitle-strong cl-black'>
                                            {store.address.province.title}
                                            ،
                                            {store.address.county.title}
                                        </div>
                                        <div className='mobile-body-1-regular cl-subtitle mt-6'>
                                            استان و شهر شعبه
                                        </div>
                                    </div>
                                    <div>
                                            <div className='mobile-button-small cl-blue'>
                                                تغییر
                                            </div>
                                        </div>
                                </div>
                                <div className='divider-1px bg-gray-custom-1 mt-12'/>
                            </div>
                            <div className='col-12'>
                                <div onClick={() => setActiveModal('addresses')}
                                     className='d-flex align-items-center justify-content-between mt-12 cursor-pointer'>
                                    <div>
                                        <div className='mobile-subtitle-strong cl-black'>
                                            {store.address.address}
                                        </div>
                                        <div className='mobile-body-1-regular cl-subtitle mt-6'>
                                            آدرس دقیق
                                        </div>
                                    </div>
                                    <div>
                                        <div className='mobile-button-small cl-blue'>
                                            تغییر
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : <div className='row'>
                            {
                                addresses.length !== 0
                                    ? (
                                        <div onClick={() => setActiveModal('addresses')}
                                             className='cursor-pointer'>
                                            <div className={'add-sub-product-box mt-20'}>
                                                <div className='d-flex justify-content-center'>
                                                    <div className={'img-cnt-24'}>
                                                        <img src={"/assets/images/vectors/plus_lightblue.svg"}
                                                             alt='add address'/>
                                                    </div>
                                                </div>
                                                <div className={'mobile-subtitle-strong cl-blue mt-8 text-center'}>
                                                    اضافه کردن آدرس
                                                </div>
                                            </div>
                                        </div>
                                    )
                                    : (<div className='col-12'>
                                        <Link
                                            to={getGeneratedRoute(RouteEnumFinal.ADDRESS_ADD_URL_GENERATE)}
                                            className='td-none'>
                                            <div className={'add-sub-product-box mt-20'}>
                                                <div className='d-flex justify-content-center'>
                                                    <div className={'img-cnt-24'}>
                                                        <img src={"/assets/images/vectors/plus_lightblue.svg"}
                                                             alt='add address'/>
                                                    </div>
                                                </div>
                                                <div className={'mobile-subtitle-strong cl-blue mt-8 text-center'}>
                                                    اضافه کردن آدرس
                                                </div>
                                            </div>
                                        </Link>
                                    </div>)
                            }
                        </div>
                }
            </div>
            <div className='divider-12px bg-gray-custom-1 mt-12'/>*/}
            {/*QRcode Socials Gallery Admins*/}
            <div className='container'>
                <div className='row'>
                    {/*QR CODE*/}
                    <div className='col-12'>
                        <PanelRow
                            title='کیوآر کدساز فروشگاه'
                            href={getGeneratedRoute(RouteEnumFinal.QR_CODE_GENERATOR_URL_GENERATE, storeUsernameInUrl)}
                            rightIcon={<FontAwesomeIcon icon={faQrcode} style={{
                                fontSize: '20px',
                                fontWeight: '400',
                                color: "#424750"
                            }}/>}
                        />
                    </div>
                    {/*STATISTICS*/}
                    <div className='col-12 d-none'>
                        <PanelRow
                            title='آمار و گزارش ها'
                            href={getGeneratedRoute(RouteEnumFinal.STORE_STATISTICS_URL_GENERATE)}
                            rightIcon={<FontAwesomeIcon icon={faChartColumn} style={{
                                fontSize: '20px',
                                fontWeight: '400',
                                color: "#424750"
                            }}/>}
                        />
                    </div>
                    {/*SOCIALS*/}
                    <div className='col-12'>
                        <PanelRow
                            title='شبکه های اجتماعی'
                            href={getGeneratedRoute(RouteEnumFinal.SOCIAL_LIST_URL_GENERATE)}
                            rightIcon={<img src={"/assets/images/vectors/instagram_line_black.svg"} alt='socials'/>}
                        />
                    </div>
                    {/*GALLERY*/}
                    <div className='col-12'>
                        <PanelRow
                            hasDivider={false}
                            title='گالری'
                            href={getGeneratedRoute(RouteEnumFinal.STORE_GALLERY_URL_GENERATE)}
                            rightIcon={<img src={"/assets/images/vectors/gallery_line_black.svg"} alt='gallery'/>}
                        />
                    </div>
                </div>
            </div>
            <div className='divider-12px bg-gray-custom-1 mt-12'/>

            {/*LIST TYPE*/}
            <div className='container mt-20'>
                <div className='row'>
                    <div className='col-12'>
                        <div className='mobile-subtitle-strong cl-black'>
                            نوع لیست
                        </div>
                    </div>
                    <div className='col-12'>
                        <form>
                            <div className='form-group-list-type mt-16'>
                                <label className="form-group-label cursor-pointer">
                                    <input
                                        onChange={() => handleSubmitListType('vertical')}
                                        defaultChecked={store.listType === 'vertical'}
                                        name='list_type'
                                        type="radio"
                                        className='form-group-input'/>
                                    <div
                                        className='label-view d-flex align-items-center justify-content-between'>
                                        <div className='d-flex align-items-center'>
                                            <div className='indicator'>
                                                <div className='inner-circle'/>
                                            </div>
                                            <div className='icon-image-cnt mr-16'>
                                                <img src={"/assets/images/vectors/list_type_linear.svg"}
                                                     alt='vertical'/>
                                            </div>
                                        </div>
                                        <div className='text-box'>
                                            خطی
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <div className='form-group-list-type mt-16'>
                                <label className="form-group-label cursor-pointer">
                                    <input
                                        onChange={() => handleSubmitListType('grid')}
                                        defaultChecked={store.listType === 'grid'}
                                        name='list_type'
                                        type="radio"
                                        className='form-group-input'/>
                                    <div
                                        className='label-view d-flex align-items-center justify-content-between'>
                                        <div className='d-flex align-items-center'>
                                            <div className='indicator'>
                                                <div className='inner-circle'/>
                                            </div>
                                            <div className='icon-image-cnt mr-16'>
                                                <img src={"/assets/images/vectors/list_type_grid.svg"} alt='grid'/>
                                            </div>
                                        </div>
                                        <div className='text-box'>
                                            گرید
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <div className='form-group-list-type mt-16'>
                                <label className="form-group-label cursor-pointer">
                                    <input
                                        onChange={() => handleSubmitListType('no_pic')}
                                        defaultChecked={store.listType === 'no_pic'}
                                        name='list_type'
                                        type="radio"
                                        className='form-group-input'/>
                                    <div
                                        className='label-view d-flex align-items-center justify-content-between'>
                                        <div className='d-flex align-items-center'>
                                            <div className='indicator'>
                                                <div className='inner-circle'/>
                                            </div>
                                            <div className='icon-image-cnt mr-16'>
                                                <img src={"/assets/images/vectors/list_type_no_pic.svg"} alt='no_pic'/>
                                            </div>
                                        </div>
                                        <div className='text-box'>
                                            بدون عکس
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className='divider-12px bg-gray-custom-1 mt-40'/>
            {/*THEME*/}
            <div className='container mt-40'>
                <div className='row'>
                    <div className='col-12'>
                        <div className='mobile-subtitle-strong cl-black'>
                            تم شعبه
                        </div>
                    </div>
                    <div className="col-12">
                        <form className='mt-12'>
                            <Swiper id='swiper_themes'
                                    slidesPerView={"auto"}
                                    spaceBetween={16}
                                    className="mySwiper">
                                {
                                    themes.map(theme => {
                                        return (
                                            <SwiperSlide key={theme.code}
                                                         className={'swiper_slide_tabs w-auto'}>
                                                <div className='form-group-theme'>
                                                    <label className="form-group-label cursor-pointer">
                                                        <input value={theme.code}
                                                               name='theme_type'
                                                               defaultChecked={store.theme.code === theme.code}
                                                               onChange={() => handleSubmitTheme(theme.code)}
                                                               type="radio"
                                                               className='form-group-input'/>
                                                        <div className='label-view'>
                                                            <div className='theme-box'>
                                                                <div className='header-box'
                                                                     style={{backgroundColor: theme.primaryColor}}>
                                                                    <div className='icon-image-cnt'>
                                                                        <img src={"/assets/images/vectors/theme_set_gray.svg"} alt='theme'/>
                                                                    </div>
                                                                </div>
                                                                <div className='indicator'>
                                                                    <div className='inner-circle'/>
                                                                </div>
                                                                <div className='color-circle'
                                                                     style={{backgroundColor: theme.primaryColor}}/>
                                                            </div>
                                                            <div className='text-box mt-12 text-center'>
                                                                {theme.title}
                                                            </div>
                                                        </div>
                                                    </label>
                                                </div>
                                            </SwiperSlide>
                                        )
                                    })
                                }


                            </Swiper>
                        </form>
                    </div>
                </div>
            </div>


            {
                addresses.length &&
                <Modal className='bottom-sheet fade in'
                       show={activeModal === 'addresses'}
                       onHide={() => setActiveModal(null)}>
                    <Modal.Body>
                        <div className='d-flex justify-content-center pt-10 pb-10'
                             onClick={() => setActiveModal(null)}>
                            <div className='bottom-sheet-close-line btn p-0 '/>
                        </div>

                        <div className="row align-items-center mt-20">
                            <div className='col-8'>
                                <div className='mobile-h5 cl-black'>
                                    انتخاب آدرس فروشگاه
                                </div>
                            </div>
                            <div className='col-4'>
                                <Link
                                    to={getGeneratedRoute(RouteEnumFinal.ADDRESS_ADD_URL_GENERATE, storeUsernameInUrl)}
                                    className='td-none'>
                                    <div className="mobile-button-small cl-blue text-start">اضافه کردن</div>
                                </Link>
                            </div>
                        </div>
                        <div className='mobile-subtitle-regular cl-subtitle mt-custom-4'>
                            آدرس فروشگاه خود را انتخاب کنید :
                        </div>

                        <form onSubmit={handleSubmitAddress}>
                            {
                                addresses.map(address => {
                                    return (
                                        <div key={address.code} className='form-group-select-row-radio pt-12'>
                                            <label className="form-group-label">
                                                <input type="radio"
                                                       onChange={() => setSelectedAddress(address.code)}
                                                       value={address.code}
                                                       defaultChecked={address.code === store.address?.code}
                                                       name='guild'
                                                       className='form-group-input'/>
                                                <div className='label-view'>
                                                    <div className='row align-items-center justify-content-between'>
                                                        <div className='col-1'>
                                                            <div className='round-tick adapted-for-address-select'>
                                                                <img src={"/assets/images/vectors/tick_blue.svg"}
                                                                     alt='add address'/>
                                                            </div>
                                                        </div>
                                                        <div className='col-10'>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='mobile-h4 cl-black'>
                                                                    {address.title}
                                                                </div>
                                                                <div
                                                                    className='mobile-body-2-regular cl-subtitle mr-custom-4'>
                                                                ( {address.province.title}, {address.county.title} )
                                                                </div>
                                                            </div>
                                                            <div className='mobile-subtitle-regular cl-black mt-16'>
                                                                {address.address}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='divider-1px bg-gray-custom-1 mt-16'/>
                                                </div>
                                            </label>
                                        </div>
                                    )
                                })
                            }
                            <div className='mt-32'>
                                <ButtonPrimary text='ثبت'
                                               mode='dark-mode'
                                               isLoading={isSubmittingAddress}/>
                            </div>
                        </form>

                    </Modal.Body>
                </Modal>
            }
            <div className='scroll-fixer'/>

        </>
    );
}


export default Panel